import React from "react";
import ReactDOM from "react-dom";

import BaseComponent from "../baseComponent.js";
import DashboardService from "../../core/services/dashboardService.js";

import Grid from "./grid/grid.jsx";
import ResizeGrid from "./grid/resizeGrid.jsx"
import styles from "./styles.scss";
import Subscription from "./subscription/subscription.jsx";

export default class DashboardBody extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      dashboard: props.dashboard
    };
  }

  componentDidMount() {
    this.hidePreloader();
    ReactDOM.render(React.createElement(ResizeGrid, {
      dashboardState: this.state.dashboard.state
    }), document.getElementById("resizeGrid-container"));
  }

  componentWillUnmount() {
    ReactDOM.unmountComponentAtNode(document.getElementById("resizeGrid-container"));
  }

  saveDashboardState(dashboardStateId, dashboardState) {
    this.showPreloader();
    DashboardService.updateDashboardState(this.state.dashboard.persistenceId, dashboardStateId, dashboardState)
      .then(() => {
        this.hidePreloader();
        ReactDOM.unmountComponentAtNode(document.getElementById("resizeGrid-container"));
        ReactDOM.render(React.createElement(ResizeGrid, {
          dashboardState: this.state.dashboard.state
        }), document.getElementById("resizeGrid-container"));
      });
  }

  render() {
    return (
      <div id="gridster-wrapper" className={styles.dashboardBodyContainer} ref="container">
        <Grid dashboardState={this.state.dashboard.state}
              router={this.props.router}
              onVariableUpdated={this.props.onVariableUpdated}
              updateDashboardVariable={this.props.updateDashboardVariable}
              onResizeAll={this.remountResizeGrid}
              onWidgetChange={(id, state) => this.saveDashboardState(id, state)}/>
        <div id="resizeGrid-container">
        </div>
        <div id="tooltips-container">
        </div>
        <Subscription onReload={this.props.reloadDashboard}/>

      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/dashboardBody.jsx